<template>
  <div class="download-page">
    <div class="download-modal">
      <div class="header">
        <icon name="download"></icon>
        {{ $t('download.downloadX', { type }) }}
      </div>
      <div class="body">
        <p>
          {{ $t('download.downloadInAFewSeconds') }}
          <a @click="startDownload" href="#">{{ $t('download.ifDoesntStart') }}</a>
        </p>
        <!-- <AppButton
          v-if="!hasStarted"
          :action="startDownload"
          :text="$t('download.startDownload')"
          iconName="download"
          class="" /> -->
        <!-- <div v-else>
          <div v-if="!hasError">
            <div v-if="!isComplete">
              <p>{{ $t('download.downloadingYourX', { type }) }} {{ progress }}%</p> -->
              <!-- progress bar? -->
            <!-- </div>
            <p v-else>{{ $t('download.downloadedSuccessfully') }}</p>
          </div>
          <div v-else>
            <message
              type="error"
              iconName="exclamation-triangle">
              {{ $t('download.errorWhileDownloading', { type }) }}
            </message>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as Sentry from '@sentry/browser'
// Uncomment to re-enable Amplitude tracking
// import amplitude from 'amplitude-js'
import { determineFileName, determineMimeType, save } from '@/utils/download'

// import AppButton from '@/components/AppButton'
// import Message from '@/components/Message'

export default {
  name: 'DownloadPage',
  components: {
    // AppButton,
    // Message
  },
  props: {
    type: {
      type: String,
      required: false,
      default: 'envelope',
      validator: val => ['envelope', 'document'].includes(val)
    }
  },
  data () {
    return {
      hasStarted: false,
      progress: 0,
      isComplete: false,
      hasError: false,
      timeout: null
    }
  },
  mounted () {
    this.timeout = window.setTimeout(this.startDownload, 200)
  },
  methods: {
    async startDownload () {
      this.hasStarted = true
      // Uncomment to re-enable Amplitude tracking
      // amplitude.getInstance().logEvent('message_sent')
      await this.download()
    },
    async download () {
      try {
        /**
         * Access token is automatically provided by defaults in App.vue
         */
        const { data, headers } = await axios.get(`${process.env.VUE_APP_API_URL}/download/${this.type}`, {
          responseType: 'blob', // this is important
          onDownloadProgress: ev => {
            this.progress = Math.round((ev.loaded / ev.total) * 100)
          }
        })

        const filename = determineFileName(headers) || determineMimeType({ backupFileName: 'Documents', mimeType: data.type })
        save(data, filename)
        this.isComplete = true
      } catch (e) {
        Sentry.captureException(e)
        this.hasError = true
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  .download-page
    position: absolute
    display: flex
    justify-content: center
    align-items: center
    width: 100vw
    height: 100vh
    min-height: 100%
    background-color: #0095e6
    color: #555
    z-index: 100

    a, a:visited
      color: #0095e6

  .download-modal
    width: 295px
    margin: 5px
    background-color: #fff
    border-radius: 3px
    box-shadow: 0px 0px 10px #00000029
    padding: 20px

    .header
      font-weight: 600
      font-size: 20px
      *
        vertical-align: middle

    .body
      font-size: 14px
      padding-top: 10px

    p
      margin: 0
      padding-top: 5px
</style>
